const WalletIcon = ({ ...props }) => {
  const { color = 'var(--pcm-body-color)' } = props;
  return (
    <svg width='20' height='20' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.5 8.27428C10.6716 8.27428 10 8.97267 10 9.83416C10 10.6957 10.6716 11.394 11.5 11.394H15V13.7599C14.9948 14.4486 14.4548 15.0032 13.7925 15H4.2075C3.5452 15.0032 3.00522 14.4486 3 13.7599V6.22303C3.02008 5.50911 3.56409 4.93094 4.25 4.89453H13.75C14.4359 4.93094 14.9799 5.50911 15 6.22303V8.27428H11.5ZM10.509 2.1372C11.1011 1.82442 11.8247 2.06422 12.1339 2.67561L12.9613 4.32198L6.25941 4.37402L10.509 2.1372ZM11.4964 8.79199C12.0493 8.79199 12.4975 9.25807 12.4975 9.83301C12.4975 10.4079 12.0493 10.874 11.4964 10.874C10.9436 10.874 10.4954 10.4079 10.4954 9.83301C10.4954 9.25807 10.9436 8.79199 11.4964 8.79199Z'
        fill={color}
      />
    </svg>
  );
};

export default WalletIcon;
